
import { computed, getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'
import api from '@/api/api'
import { getWebhook } from '@root/src/api/pendingConnectors'
import { saveCredentials } from '@root/src/api/connectors/profsalonBat'

const TASKS = [
    {
        title: 'Проверьте права аккаунта',
        body: 'Нужен аккаунт с правами владельца.',
    },
    {
        title: 'Введите логин и пароль',
        body: 'Данные нужны для первичного подключения интеграции.',
    },
    {
        title: 'Отправьте на проверку',
        body: 'Data Heroes проверит подключение и доступность данных.',
    },
]

export default {
    name: 'ProfSalonBatAuth',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)
        const credentials = ref({
            pfLogin: '',
            pfPassword: '',
        })

        const currentAddingConnector = computed(
            () => store.state.project.currentAddingConnector
        )

        const btnDisabled = computed(
            () =>
                !String(credentials.value.pfLogin || '').trim() ||
                !String(credentials.value.pfPassword || '').trim()
        )

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const submitLogin = async () => {
            loading.value = true
            syncWizardNav()

            const projectId = root.$router.currentRoute.params.id
            const pendingConnectors = await api.project.getPendingConnectorsByProject({
                projectId,
            })
            const pendingConnector = pendingConnectors.data[0]
            const adding = currentAddingConnector.value
            const connector =
                pendingConnector ??
                (await store.dispatch('project/createConnector', {
                    projectId,
                    connectorType: adding?.type ?? adding,
                }))

            store.commit('project/setLoggedAddingConnector', connector)

            const { error } = await saveCredentials(connector, credentials.value)
            if (!error) {
                if (pendingConnector) {
                    root.$parent.$emit('next')
                } else {
                    root.$parent.$emit('login')
                }
            } else {
                store.dispatch('callNotify', 'Ошибка')
            }
            loading.value = false
            syncWizardNav()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: !btnDisabled.value,
                nextLoading: loading.value,
                nextLabel: 'Далее',
                onBack: goBackToCrm,
                onNext: submitLogin,
            }),
            [loading, btnDisabled]
        )

        // Keep webhook prefetch from legacy Auth (side-effect for pending flow)
        getWebhook().catch(() => {})

        return {
            tasks: TASKS,
            credentials,
            loading,
            btnDisabled,
            hasWizardNav,
            goBackToCrm,
            submitLogin,
        }
    },
}
